import { Button } from '../button/button.tsx';

export interface JourneyFormActionsProps {
  /** A failure that belongs to no field, shown above the buttons. */
  formError?: string;
  onCancel?: () => void;
  submitting: boolean;
  labels: { submit: string; cancel: string };
}

/** The foot of a journey form: what failed outside the fields, then cancel and submit. */
export function JourneyFormActions({
  formError,
  onCancel,
  submitting,
  labels,
}: JourneyFormActionsProps) {
  return (
    <>
      {formError && (
        <p role='alert' className='text-sm text-danger'>
          {formError}
        </p>
      )}

      <div className='flex justify-end gap-2'>
        {onCancel && (
          <Button variant='quiet' onClick={onCancel}>
            {labels.cancel}
          </Button>
        )}
        <Button type='submit' loading={submitting}>
          {labels.submit}
        </Button>
      </div>
    </>
  );
}
